<template>
    <router-link :to="url" :class="kind">
        <div class="guide" ref="bg">
            <div class="icon">
                <img :src="guide.asset.img" loading="lazy"/>
                <span>
                    {{guide.name}}
                </span>
            </div>

            <div class="list">
                <div v-for="(e, i) in schedule.slice(0, scheduleLimit)" :key="i" :style="e.style">
                    <p> {{ e.name }} </p>
                    <span>
                        {{getTime(e.start)}} - {{getTime(e.end)}}
                    </span>
                </div>

            </div>
        </div>
    </router-link>
</template>

<script>
export default {
  name: 'guide',

  props: {
      guide: Object,
      kind: {
        type: String,
        default: () => { return '' }
      }
  },

  components: {
  },

  computed: {
        url: function(){
            if(this.isDesktop){
                return `/theater?mode=epg&id=${this.guide.key}`
            }else{
                return '/guide/' + this.guide.key + '/'
            }
        }
  },

  data: function(){
    return {
        schedule: [],
        ready: false,
        scheduleLimit: 20,
        pixelsPerHour: 200,
    }
  },

  methods: {
    getTime(time){ return window.getTime(time) }
  },

  mounted: function(){
    this.$nextTick(() => {
        if(this.$refs.bg){
            this.$refs.bg.style.backgroundColor = window.getAssetColor(this.guide.asset)
        }
    })

    this.guide.schedule.forEach(e => {
        const now = new Date(window.now).getTime();
        const end = new Date(e.end).getTime();

        if (end < now) return;

        const start = new Date(e.start).getTime();

        const duration = end - start;
        const hours = duration / (1000 * 60 * 60);
        const width = hours * this.pixelsPerHour;

        this.schedule.push({
            ...e,
            style: { width: width + 'px' }
        });
    });

  }
}
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
    color: white;
}

.guide{
    height: 45px;
    border-bottom: 3px solid white;
    padding: 10px;
    margin: 5;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    .list{
        display: flex;
        flex-direction: row;
        font-size: 9px;
        > div{
            min-width: 60px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            border: 1px solid white;
            border-radius: 3px;
            margin: 0 5px;
            padding: 5px;
            overflow: hidden;
            p{
                padding: 0;
                margin: 0;
                max-height: 70%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
            }
            span{
                display: block;
                font-weight: bold;

            }
        }

    }
    .icon{
        font-size: 7px;
        min-width: 80px;
        span{
            display: block;
            width: 75%;
            padding: 5px 0;
        }
        img{
            max-width: 70px;
            object-fit: contain;
            padding-right: 10px;
            height: 20px;
            display: block;
        }
    }
}

</style>
